<template>
    <div class="main-content">
        <the-header :title="t('Translator')"
                    :buttons="listHeaderButtons"
                    v-on:button-import-slugs="$refs.staticText.loadTranslates($event)"
        />
        <nav-body :links="nav">
            <static-text ref="staticText"/>
        </nav-body>
    </div>
</template>
<script>
    import TheHeader from '../../../../admin/Layout/TheHeader'
    import NavBody from '../../../../admin/Layout/NavBody'
    import StaticText from '../../../../admin/Pages/StaticText/StaticText';
    import {admin} from '../Admin'

    export default {
        mixins: [admin],
        components: {
            StaticText,
            TheHeader,
            NavBody,
        },
        mounted() {
            this.listHeaderButtons.push({
                type: 'button',
                key: 'import-slugs',
                name: this.t('Import slugs'),
                icon: 'cloud-download-alt',
                styleClass: 'btn-success',
                visible: this.i18n.areStoredStrings(),
            });
        },
        data() {
            return {
                listHeaderButtons: []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/admin/translator/Translator.vue